<template>
  <div v-if="partsListData.remarkList">
    <div class="order-solution">
      <div class="os-list">
        <div class="os-title">
          <el-row :gutter="24">
            <el-col :span="12">
              <div class="left flex-between">
                <div
                  class="title-control flex-between"
                  @click="showHandleData = !showHandleData"
                >
                  <i class="el-icon-arrow-up" v-if="!showHandleData"></i>
                  <i class="el-icon-arrow-down" v-else></i>
                </div>
                <p class="title">
                  {{ $lange == "en" ? "Remark" : "备注" }}
                </p>
                <span></span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="right flex-between">
                <el-button
                  style="width: 150px"
                  type="primary"
                  size="mini"
                  @click="addRemark = true"
                  >{{ $lange == "en" ? "Add Remark" : "添加备注" }}</el-button
                >
              </div>
            </el-col>
          </el-row>
        </div>
        <el-collapse-transition>
          <div class="li_wrap" v-if="showHandleData">
            <div
              class="null_remark"
              v-if="partsListData.remarkList.length == 0"
            >
              无数据
            </div>
            <div
              class="li"
              v-for="(li, index) in partsListData.remarkList"
              :key="index"
            >
              <!-- 手动添加备注 || 取消配件订单 -->
              <el-alert
                type="info"
                :closable="false"
                v-if="li.objType == 0 || li.objType == 5"
              >
                <template v-slot:title>
                  <div class="title_wrap">
                    <h3 class="title">{{ li.createTime }}</h3>
                    <h3 class="title">{{ li.handlerName }}</h3>
                    <h3 class="title">
                      {{ li.objType == 0 ? "添加备注" : "取消配件订单" }}
                    </h3>
                  </div>
                </template>
                <template>
                  <div class="remark_wrap">
                    <div>{{ li.remark }}</div>
                  </div>
                </template>
              </el-alert>

              <!--  修改配件明细 || 向客户推送方案 -->
              <el-alert
                type="info"
                :closable="false"
                v-if="li.objType == 1 || li.objType == 2"
              >
                <template v-slot:title>
                  <div class="title_wrap">
                    <h3 class="title">{{ li.createTime }}</h3>
                    <h3 class="title">{{ li.handlerName }}</h3>
                    <h3 class="title">
                      {{ li.objType == 1 ? "修改订单明细" : "推送客户" }}
                    </h3>
                  </div>
                </template>
                <template>
                  <div class="remark_wrap">
                    <div
                      class="li_data"
                      v-for="(goods, ind) in li.extraData"
                      :key="ind"
                    >
                      <div style="width: 200px">
                        {{ $lange == "en" ? "FAS Code" : "FAS料号" }}：{{
                          goods.parts.fasCode
                        }}
                      </div>
                      <div style="width: 150px">
                        {{ $lange == "en" ? "Quantity" : "申请数量" }}：{{
                          goods.partsNum
                        }}
                      </div>
                      <div :style="$lange == 'en' ?'width: 150px': 'width: 100px'">
                        {{ $lange == "en" ? "Warehouse" : "仓库" }}：{{
                          wareAddress[goods.wareAddress]
                        }}
                      </div>
                      <div :style="$lange == 'en' ?'width: 150px': 'width: 100px'">
                        {{ $lange == "en" ? "Cost Type" : "费用类型" }}：{{
                          feeType[goods.feeType]
                        }}
                      </div>
                      <div style="width: 150px" v-if="goods.salePrice!==undefined">
                        {{ $lange == "en" ? "Listed Price" : "价格" }}：{{
                          price(goods.salePrice, 2)
                        }}
                      </div>
                      <div style="width: 150px"  v-if="goods.discount!==undefined">
                        {{ $lange == "en" ? "Discount" : "折扣" }}：{{
                          price(goods.discount, 1)
                        }}
                      </div>
                      <div   v-if="goods.relPrice!==undefined">
                        {{ $lange == "en" ? "Offer Price" : "最终报价" }}：{{
                          price(goods.relPrice, 2)
                        }}
                      </div>
                    </div>
                    <div class="allPrice">
                      {{$lange == "en" ? "Total" :"总计"}}：¥{{ allPrice(li.extraData) }}
                    </div>
                    <div
                      v-if="
                        li.extraData &&
                        li.extraData.length > 0 &&
                        li.extraData[0].priceTerms !== undefined
                      "
                    >
                      {{$lange == "en" ? "Quotation method" :"报价方式"}}：{{
                        priceTermsListText[li.extraData[0].priceTerms]
                      }}
                    </div>
                  </div>
                </template>
              </el-alert>

              <!-- 向客户推送货品信息 -->
              <el-alert type="info" :closable="false" v-if="li.objType == 3">
                <template v-slot:title>
                  <div class="title_wrap">
                    <h3 class="title">{{ li.createTime }}</h3>
                    <h3 class="title">{{ li.handlerName }}</h3>
                    <h3 class="title">推送货品信息</h3>
                  </div>
                </template>
                <template>
                  <div class="remark_wrap">
                    <div>快递单号：{{ li.extraData }}</div>
                  </div>
                </template>
              </el-alert>

              <!-- 配件退回/取消 -->
              <el-alert type="info" :closable="false" v-if="li.objType == 4">
                <template v-slot:title>
                  <div class="title_wrap">
                    <h3 class="title">{{ li.createTime }}</h3>
                    <h3 class="title">{{ li.handlerName }}</h3>
                    <h3 class="title">退回/取消配件</h3>
                  </div>
                </template>
                <template>
                  <div class="remark_wrap">
                    <div
                      class="li_data"
                      v-for="(goods, ind) in li.extraData.cancelPoList"
                      :key="ind"
                    >
                      <div style="width: 200px">
                        {{ $lange == "en" ? "FAS Code" : "FAS料号" }}：{{
                          goods.fasCode
                        }}
                      </div>
                      <div style="width: 150px">
                        {{
                          $lange == "en" ? "退回/取消数量" : "退回/取消数量"
                        }}：{{ goods.num }}
                      </div>
                    </div>
                    <div>说明：{{ li.remark }}</div>
                  </div>
                </template>
              </el-alert>
            </div>
          </div>
        </el-collapse-transition>
      </div>
    </div>

    <el-dialog
      :title="$lange == 'en' ? 'Add remark' : '添加备注'"
      :visible.sync="addRemark"
      width="50%"
      append-to-body
    >
      <el-input
        size="mini"
        type="textarea"
        :rows="4"
        v-model="remarkMsg"
        :placeholder="$lange == 'en' ? 'Please enter remark' : '请输入备注'"
      ></el-input>
      <div class="add_remark_button">
        <el-button type="primary" size="small" @click="saveRemark">{{
          $lange == "en" ? "Submit" : "保存"
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    partsListData: Object,
  },
  data() {
    return {
      showHandleData: true,
      addRemark: false,
      remarkMsg: "",
      priceTermsListText:  [this.$lange == "en" ? "offline" :"线上",  this.$lange == "en" ? "online" :"线下"],
      feeType: [ this.$lange == "en" ? "Free" : "保内", this.$lange == "en" ? "Paid" : "保外"],
      wareAddress: {
        fsWarehouse: "佛山",
        tjWarehouse: "天津",
        shWarehouse: "上海",
        cdWarehouse: "成都",
        consignmentSale: "寄售",
      },
    };
  },
  computed: {},
  methods: {
    allPrice(data) {
      let num = "0";
      for (let index = 0; index < data.length; index++) {
        if (data[index].feeType == 1) {
          if (data[index].relPrice != undefined) {
            num = this.accAdd(num, data[index].relPrice);
          }
        }
      }
      return (num / 100).toFixed(1);
    },
    accAdd(arg1, arg2) {
      var r1, r2, m;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      return (arg1 * m + arg2 * m) / m;
    },
    price(num, index) {
      if (num == undefined) {
        return "";
      }
      return (num / 100).toFixed(index);
    },
    saveRemark() {
      let remarkMsg = this.remarkMsg.replace(/(^\s*)|(\s*$)/g, "");
      if (remarkMsg == "") {
        this.$message.error("请输入备注");
        return false;
      }
      let data = {
        remark: this.remarkMsg,
        partsOrderId: this.partsListData.id,
      };
      this.ccRequest
        .do("admin/fsb/parts/order/addRemark", data, "GET")
        .then((res) => {
          this.$message({
            type: "success",
            message: "添加成功",
          });
          this.remarkMsg = "";
          this.addRemark = false;
          // this.$emit("updateOrder", { code: "remarkList",});
          this.$emit("updateOrder", true);
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
  },
};
</script>
<style scoped lang="scss">
.order-solution {
  background: #ffffff;
  margin-top: 5px;

  .os-list {
    padding: 20px;
    // border-bottom: 1px dotted #ccc;
    // border-top: 5px solid #f3f3f4;
    .os-title {
      .left {
        justify-content: flex-start;

        > * {
          margin-left: 80px;
        }

        .title-control {
          padding: 0px;
          border-radius: 5px;
          border: 1px solid #e4e4e4;
          width: 24px;
          height: 24px;
          justify-content: center;
          font-size: 20px;
          cursor: pointer;
          margin-left: 0;
          & ~ .title {
            font-weight: bolder;
            color: #6f6f6f;
            width: 200px;
          }
        }

        .title {
          font-size: 18px;
          margin-left: 20px;
        }
      }
    }
  }
}
.li_wrap {
  margin-top: 20px;
  .li {
    margin-bottom: 20px;
  }
}
.remark_wrap {
  font-size: 14px;
  color: #000 !important;
}
.right {
  display: flex;
  // justify-content: end;
  justify-content: flex-end;
}
.add_remark_button {
  margin-top: 15px;
  display: flex;
  justify-content: center;
}
.title_wrap {
  display: flex;
  color: #000;
  padding: 10px 0;
  font-size: 12px !important;
  .title {
    margin-right: 10px;
    // font-size: 18px;
  }
}
.null_remark {
  text-align: center;
  padding: 10px;
  color: #c3c1c1;
}
.li_data {
  display: flex;
  margin-top: 10px;
  flex-wrap: wrap;
  // font-size: 16px;
  div {
    margin-right: 20px;
    margin-bottom: 5px;
  }
}
.allPrice {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>